import { Button } from '@mui/material';
import React from 'react'
import { Document, Page, pdfjs } from 'react-pdf';
import './ViewerPDF.css'
import DownloadIcon from '@mui/icons-material/Download';


type Props = {
  file: string
  filename: string
}

const ViewerPDF = (props: Props) => {

  const { file, filename } = props;

  const [numPages, setNumPages] = React.useState(null);
  const [pageNumber, setPageNumber] = React.useState(1);

  React.useEffect(() => {
    pdfjs.GlobalWorkerOptions.workerSrc = `https://cdnjs.cloudflare.com/ajax/libs/pdf.js/${pdfjs.version}/pdf.worker.js`;
  }, [])

  function onDocumentLoadSuccess({ numPages }: any) {
    setNumPages(numPages);
  }

  return (
    <>
      <a href={file} target="_blank" rel="noopener noreferrer" download={filename+".pdf"} title="Download PDF">
        <Button
          color='primary'
          startIcon={<DownloadIcon />}
          disableElevation
          variant='contained'
        >
          Download PDF
        </Button>
      </a>
      <Document file={file} onLoadSuccess={onDocumentLoadSuccess}>
          <Page pageNumber={pageNumber} />
      </Document>
    </>
  )
}

export default ViewerPDF